import createVueApp from '@/common/createApp'

Styxie.Initializers.AffiliateHistories = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/affiliate/histories/index.vue')
    createVueApp(Component, { props })
  }
}
